import { useDispatch, useSelector } from 'react-redux';
import { Button, StandAloneLink } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { setScrollToTransitionConsent } from '@app/redux/changePlan';
import { selectConfig } from '@app/redux/config';

import styles from './SubmitSection.module.scss';

type SubmitSectionProps = {
  handlePlacePlanOrder: () => void;
  handleBackNavigation: () => void;
  requiresEquipmentChange: boolean;
  isEicChecked?: boolean;
  hasAttemptedSubmit?: boolean;
};

const SubmitSection = ({
  handlePlacePlanOrder,
  handleBackNavigation,
  requiresEquipmentChange,
  isEicChecked = false,
  hasAttemptedSubmit = false,
}: SubmitSectionProps) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('ChangePlan', {
    keyPrefix: 'orderReview.cartDetails',
  });

  const handleClick = () => {
    if (hasAttemptedSubmit && !isEicChecked) {
      dispatch(setScrollToTransitionConsent(true));

      return;
    }
    handlePlacePlanOrder();
  };

  return (
    <div data-cy="submit-section" className={styles['submitContainer']}>
      <Button
        onClick={handleClick}
        data-cy="submit-order-button"
        style={{ maxWidth: '400px', width: '100%', alignSelf: 'center' }}
      >
        {requiresEquipmentChange ? t('next') : t('placeOrderButton')}
      </Button>

      {requiresEquipmentChange && (
        <StandAloneLink
          data-cy="back-to-plan-review-link"
          onClick={(event) => {
            event.preventDefault();
            handleBackNavigation && handleBackNavigation();
          }}
          href="#"
          underline={true}
          linkSize="medium"
          style={{ textAlign: 'center', alignSelf: 'center' }}
        >
          {t('backToPlanReview')}
        </StandAloneLink>
      )}
    </div>
  );
};

export default SubmitSection;
